import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import DateFilter from './DateFilter';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const UsageChart = ({ data, period, onPeriodChange, customDates, onCustomDateChange }) => {
  const usageOptions = [
    { value: 'today', label: 'Today' },
    { value: 'last_week', label: 'Last Week' },
    { value: 'last_month', label: 'Last Month' },
    { value: 'last_6_months', label: 'Last 6 Months' },
    { value: 'custom', label: 'Custom' }
  ];

  if (!data || data.length === 0) {
    return (
      <div>
        <DateFilter
          value={period}
          onChange={onPeriodChange}
          options={usageOptions}
          label="Period:"
          showCustom={true}
          customDates={customDates}
          onCustomDateChange={onCustomDateChange}
        />
        <div className="no-data">No usage data available</div>
      </div>
    );
  }

  const chartData = {
    labels: data.map(item => {
      const date = new Date(item.date);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }),
    datasets: [
      {
        label: 'Active Companies',
        data: data.map(item => item.active_companies),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        tension: 0.1,
      },
      {
        label: 'Active Users',
        data: data.map(item => item.active_users),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        tension: 0.1,
      },
      {
        label: 'Total Usage',
        data: data.map(item => item.total_usage),
        borderColor: 'rgb(54, 162, 235)',
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="usage-chart">
      <DateFilter
        value={period}
        onChange={onPeriodChange}
        options={usageOptions}
        label="Period:"
        showCustom={true}
        customDates={customDates}
        onCustomDateChange={onCustomDateChange}
      />
      <Line data={chartData} options={options} />
    </div>
  );
};

export default UsageChart; 